import { useQuery } from '@tanstack/react-query'
import { analyticsService } from '../../../shared/api/services/analytics.service'
import { mockCategoryData, mockPerformance } from '../data/mockAnalytics'
import type { MonthlyRevenue } from '../types/analytics.types'

export const useAnalytics = () => {
    const { data: revenueResponse } = useQuery({
        queryKey: ['revenue-analytics', 'year'],
        queryFn: () => analyticsService.getRevenueAnalytics('year'),
    })

    const sortedData = (revenueResponse?.data || []).slice().sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
    const revenueData: MonthlyRevenue[] = sortedData.map(item => {
        const d = new Date(item.date)
        const label = isNaN(d.getTime()) ? item.date : d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
        return {
            month: label,
            revenue: item.revenue
        }
    })

    const totalRevenue = revenueData.reduce((sum, item) => sum + item.revenue, 0)
    const totalOrders = mockCategoryData.reduce((sum, item) => sum + item.orders, 0)

    return {
        revenueData,
        categoryData: mockCategoryData,
        performance: mockPerformance,
        totalRevenue,
        totalOrders,
    }
}
